import { View } from "binder"
import { ToolTypeEditorViewModel } from "./toolTypeEditor-viewModel"

export class ToolTypeEditorView extends View<ToolTypeEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-1AEFE539-9AB6-4454-BAC5-39DF6226C08A"
    }
    loadHtml(): string {
        let element = require('./toolTypeEditor.html').default;
        let style = require('./toolTypeEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
